import { render, staticRenderFns } from "./BreakdownBar.vue?vue&type=template&id=0c096429"
import script from "./BreakdownBar.vue?vue&type=script&lang=js"
export * from "./BreakdownBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports